export const translations = {
  pt: {
    nav: {
      home: 'Início',
      packages: 'Experiências',
      accommodations: 'Hospedagens',
      about: 'Sobre',
      contact: 'Contato'
    },
    hero: {
      title: 'EuroWineExperience',
      subtitle: 'Enoturismo Premium em Portugal',
      description: 'Descubra as melhores experiências vinícolas de Portugal com tours exclusivos, degustações premium, hospedagens de luxo e gastronomia de excelência.',
      cta: 'Explorar Experiências',
      ctaSecondary: 'Fale no WhatsApp'
    },
    packages: {
      title: 'Nossas Experiências Premium',
      subtitle: 'Vinícolas, tours guiados, city tours e passeios culturais',
      from: 'A partir de',
      perPerson: '/pessoa',
      perNight: '/noite',
      viewDetails: 'Ver Detalhes',
      reserve: 'Reservar',
      duration: 'Duração',
      groupSize: 'Tamanho do Grupo',
      includes: 'O que inclui',
      options: 'Opções',
      filterAll: 'Todas',
      filterWinery: 'Vinícolas',
      filterTours: 'Tours',
      filterCityTour: 'City Tours',
      filterDayTrip: 'Passeios de 1 Dia'
    },
    accommodations: {
      title: 'Hospedagens Selecionadas em Lisboa',
      subtitle: 'Hotéis boutique e de luxo no centro histórico',
      perNight: '/noite',
      viewDetails: 'Ver Hotel',
      bookNow: 'Reservar Hospedagem',
      amenities: 'Comodidades',
      rating: 'Avaliação',
      distanceCenter: 'Distância do Centro',
      distanceAirport: 'Distância do Aeroporto',
      stars: 'estrelas'
    },
    about: {
      title: 'Sobre Nós',
      subtitle: 'Especialistas em Enoturismo Premium em Portugal',
      description1: 'A EuroWineExperience é uma empresa especializada em experiências de enoturismo de luxo em Portugal, conectando viajantes apaixonados por vinho às melhores vinícolas, tours e experiências gastronômicas do país.',
      description2: 'Com parcerias exclusivas com as melhores vinícolas portuguesas - Quinta das Murgas, Bacalhôa, AdegaMãe, Sogrape - e operadores premium como VinoTours e Living Tours, oferecemos experiências autênticas e inesquecíveis.',
      description3: 'Nossa missão é proporcionar momentos únicos através da combinação perfeita entre vinhos excepcionais, gastronomia de excelência, hospedagens selecionadas e a rica história vinícola portuguesa.',
      values: 'Nossos Valores',
      value1: 'Excelência',
      value1Desc: 'Padrão premium em cada detalhe',
      value2: 'Autenticidade',
      value2Desc: 'Experiências genuínas e locais',
      value3: 'Sustentabilidade',
      value3Desc: 'Respeito aos vinhedos e tradições'
    },
    contact: {
      title: 'Entre em Contato',
      subtitle: 'Estamos aqui para criar sua experiência perfeita',
      name: 'Nome completo',
      email: 'E-mail',
      phone: 'Telefone',
      package: 'Pacote de interesse',
      selectPackage: 'Selecione um pacote',
      message: 'Mensagem',
      send: 'Enviar Mensagem',
      whatsappText: 'Ou fale conosco diretamente no WhatsApp',
      whatsappButton: 'Abrir WhatsApp'
    },
    testimonials: {
      title: 'O Que Dizem Nossos Clientes',
      subtitle: 'Experiências autênticas compartilhadas'
    },
    faq: {
      title: 'Perguntas Frequentes',
      subtitle: 'Tudo o que você precisa saber'
    },
    footer: {
      tagline: 'Enoturismo Premium em Portugal',
      quickLinks: 'Links Rápidos',
      contact: 'Contato',
      follow: 'Siga-nos',
      newsletter: 'Newsletter',
      newsletterText: 'Receba ofertas exclusivas e novidades',
      emailPlaceholder: 'Seu e-mail',
      subscribe: 'Inscrever',
      rights: 'Todos os direitos reservados.'
    },
    booking: {
      title: 'Reservar',
      selectDate: 'Selecione a data',
      selectTime: 'Horário preferido',
      numberOfPeople: 'Número de pessoas',
      tastingOption: 'Opção de degustação',
      mealOption: 'Opção de refeição',
      specialRequests: 'Pedidos especiais',
      total: 'Total',
      proceedPayment: 'Prosseguir para Pagamento',
      bookingSuccess: 'Reserva realizada com sucesso!',
      bookingError: 'Erro ao processar reserva. Tente novamente.'
    }
  },
  en: {
    nav: {
      home: 'Home',
      packages: 'Experiences',
      accommodations: 'Accommodations',
      about: 'About',
      contact: 'Contact'
    },
    hero: {
      title: 'EuroWineExperience',
      subtitle: 'Premium Wine Tourism in Portugal',
      description: 'Discover the best wine experiences in Portugal with exclusive tours, premium tastings, luxury accommodations and excellent gastronomy.',
      cta: 'Explore Experiences',
      ctaSecondary: 'WhatsApp Us'
    },
    packages: {
      title: 'Our Premium Experiences',
      subtitle: 'Wineries, guided tours, city tours and cultural trips',
      from: 'From',
      perPerson: '/person',
      perNight: '/night',
      viewDetails: 'View Details',
      reserve: 'Book Now',
      duration: 'Duration',
      groupSize: 'Group Size',
      includes: 'What\'s Included',
      options: 'Options',
      filterAll: 'All',
      filterWinery: 'Wineries',
      filterTours: 'Tours',
      filterCityTour: 'City Tours',
      filterDayTrip: 'Day Trips'
    },
    accommodations: {
      title: 'Selected Accommodations in Lisbon',
      subtitle: 'Boutique and luxury hotels in the historic center',
      perNight: '/night',
      viewDetails: 'View Hotel',
      bookNow: 'Book Accommodation',
      amenities: 'Amenities',
      rating: 'Rating',
      distanceCenter: 'Distance from Center',
      distanceAirport: 'Distance from Airport',
      stars: 'stars'
    },
    about: {
      title: 'About Us',
      subtitle: 'Premium Wine Tourism Specialists in Portugal',
      description1: 'EuroWineExperience is a company specialized in luxury wine tourism experiences in Portugal, connecting wine-passionate travelers with the best wineries, tours and gastronomic experiences in the country.',
      description2: 'With exclusive partnerships with the best Portuguese wineries - Quinta das Murgas, Bacalhôa, AdegaMãe, Sogrape - and premium operators like VinoTours and Living Tours, we offer authentic and unforgettable experiences.',
      description3: 'Our mission is to provide unique moments through the perfect combination of exceptional wines, excellent gastronomy, selected accommodations and Portugal\'s rich wine history.',
      values: 'Our Values',
      value1: 'Excellence',
      value1Desc: 'Premium standard in every detail',
      value2: 'Authenticity',
      value2Desc: 'Genuine and local experiences',
      value3: 'Sustainability',
      value3Desc: 'Respect for vineyards and traditions'
    },
    contact: {
      title: 'Get in Touch',
      subtitle: 'We\'re here to create your perfect experience',
      name: 'Full name',
      email: 'Email',
      phone: 'Phone',
      package: 'Package of interest',
      selectPackage: 'Select a package',
      message: 'Message',
      send: 'Send Message',
      whatsappText: 'Or contact us directly on WhatsApp',
      whatsappButton: 'Open WhatsApp'
    },
    testimonials: {
      title: 'What Our Clients Say',
      subtitle: 'Authentic shared experiences'
    },
    faq: {
      title: 'Frequently Asked Questions',
      subtitle: 'Everything you need to know'
    },
    footer: {
      tagline: 'Premium Wine Tourism in Portugal',
      quickLinks: 'Quick Links',
      contact: 'Contact',
      follow: 'Follow Us',
      newsletter: 'Newsletter',
      newsletterText: 'Receive exclusive offers and news',
      emailPlaceholder: 'Your email',
      subscribe: 'Subscribe',
      rights: 'All rights reserved.'
    },
    booking: {
      title: 'Book',
      selectDate: 'Select date',
      selectTime: 'Preferred time',
      numberOfPeople: 'Number of people',
      tastingOption: 'Tasting option',
      mealOption: 'Meal option',
      specialRequests: 'Special requests',
      total: 'Total',
      proceedPayment: 'Proceed to Payment',
      bookingSuccess: 'Booking successful!',
      bookingError: 'Error processing booking. Please try again.'
    }
  },
  es: {
    nav: {
      home: 'Inicio',
      packages: 'Experiencias',
      accommodations: 'Alojamiento',
      about: 'Sobre Nosotros',
      contact: 'Contacto'
    },
    hero: {
      title: 'EuroWineExperience',
      subtitle: 'Enoturismo Premium en Portugal',
      description: 'Descubre las mejores experiencias vinícolas de Portugal con tours exclusivos, degustaciones premium, alojamientos de lujo y gastronomía de excelencia.',
      cta: 'Explorar Experiencias',
      ctaSecondary: 'WhatsApp'
    },
    packages: {
      title: 'Nuestras Experiencias Premium',
      subtitle: 'Bodegas, tours guiados, city tours y excursiones culturales',
      from: 'Desde',
      perPerson: '/persona',
      perNight: '/noche',
      viewDetails: 'Ver Detalles',
      reserve: 'Reservar',
      duration: 'Duración',
      groupSize: 'Tamaño del Grupo',
      includes: 'Qué incluye',
      options: 'Opciones',
      filterAll: 'Todas',
      filterWinery: 'Bodegas',
      filterTours: 'Tours',
      filterCityTour: 'City Tours',
      filterDayTrip: 'Excursiones de 1 Día'
    },
    accommodations: {
      title: 'Alojamientos Seleccionados en Lisboa',
      subtitle: 'Hoteles boutique y de lujo en el centro histórico',
      perNight: '/noche',
      viewDetails: 'Ver Hotel',
      bookNow: 'Reservar Alojamiento',
      amenities: 'Servicios',
      rating: 'Valoración',
      distanceCenter: 'Distancia del Centro',
      distanceAirport: 'Distancia del Aeropuerto',
      stars: 'estrellas'
    },
    about: {
      title: 'Sobre Nosotros',
      subtitle: 'Especialistas en Enoturismo Premium en Portugal',
      description1: 'EuroWineExperience es una empresa especializada en experiencias de enoturismo de lujo en Portugal, conectando viajeros apasionados por el vino con las mejores bodegas, tours y experiencias gastronómicas del país.',
      description2: 'Con alianzas exclusivas con las mejores bodegas portuguesas - Quinta das Murgas, Bacalhôa, AdegaMãe, Sogrape - y operadores premium como VinoTours y Living Tours, ofrecemos experiencias auténticas e inolvidables.',
      description3: 'Nuestra misión es proporcionar momentos únicos a través de la combinación perfecta entre vinos excepcionales, gastronomía de excelencia, alojamientos seleccionados y la rica historia vinícola portuguesa.',
      values: 'Nuestros Valores',
      value1: 'Excelencia',
      value1Desc: 'Estándar premium en cada detalle',
      value2: 'Autenticidad',
      value2Desc: 'Experiencias genuinas y locales',
      value3: 'Sostenibilidad',
      value3Desc: 'Respeto a los viñedos y tradiciones'
    },
    contact: {
      title: 'Contáctanos',
      subtitle: 'Estamos aquí para crear tu experiencia perfecta',
      name: 'Nombre completo',
      email: 'Correo electrónico',
      phone: 'Teléfono',
      package: 'Paquete de interés',
      selectPackage: 'Selecciona un paquete',
      message: 'Mensaje',
      send: 'Enviar Mensaje',
      whatsappText: 'O contáctanos directamente por WhatsApp',
      whatsappButton: 'Abrir WhatsApp'
    },
    testimonials: {
      title: 'Lo Que Dicen Nuestros Clientes',
      subtitle: 'Experiencias auténticas compartidas'
    },
    faq: {
      title: 'Preguntas Frecuentes',
      subtitle: 'Todo lo que necesitas saber'
    },
    footer: {
      tagline: 'Enoturismo Premium en Portugal',
      quickLinks: 'Enlaces Rápidos',
      contact: 'Contacto',
      follow: 'Síguenos',
      newsletter: 'Newsletter',
      newsletterText: 'Recibe ofertas exclusivas y novedades',
      emailPlaceholder: 'Tu correo',
      subscribe: 'Suscribirse',
      rights: 'Todos los derechos reservados.'
    },
    booking: {
      title: 'Reservar',
      selectDate: 'Selecciona la fecha',
      selectTime: 'Horario preferido',
      numberOfPeople: 'Número de personas',
      tastingOption: 'Opción de degustación',
      mealOption: 'Opción de comida',
      specialRequests: 'Solicitudes especiales',
      total: 'Total',
      proceedPayment: 'Proceder al Pago',
      bookingSuccess: '¡Reserva realizada con éxito!',
      bookingError: 'Error al procesar la reserva. Inténtalo de nuevo.'
    }
  }
};
